/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectorRef, Component, Inject, OnInit} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';
import * as _ from 'lodash';

import template from './creative-from-line-item-copy-modal.component.html';
import {Uuid} from '../../components/util/uuid';
import {CreativeResource} from '../../components/api/resources/resource/creative.resource';
import {deferMarkForCheck} from '../common/util/defer-mark-for-check';

@Component({
  standalone: false,
  selector: 'adn-creative-from-line-item-copy-modal',
  template
})
export class CreativeFromLineItemCopyModalComponent implements OnInit {
  destinationLineItem: any;
  destinationLineItemName = 'This Line Item';
  specifiedAdvertiser: any;
  preselectCurrentLineItem = false;
  perms: any = {};
  onClosed: () => void;

  lineItem: any;
  lineItemName = 'This Line Item';
  newName = '{currentName} (Copy)';
  creativeFilterText = '';
  creatives: any[];
  loadingCreatives = false;
  disabled = false;

  constructor(
    public bsModalRef: BsModalRef,
    @Inject(CreativeResource) private readonly Creative: any,
    private readonly cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit(): void {
    this.lineItemName = this.destinationLineItemName || this.destinationLineItem?.name || 'This Line Item';
    if (this.preselectCurrentLineItem && this.destinationLineItem) {
      this.lineItem = this.destinationLineItem;
      this.onSelect();
    }
  }

  get creativesResolved(): boolean {
    return this.creatives !== undefined && !this.loadingCreatives;
  }

  get filteredCreatives(): any[] {
    const filterText = (this.creativeFilterText || '').toLowerCase();
    return (this.creatives || []).filter((creative) => {
      return !filterText || _.get(creative, 'name', '').toLowerCase().indexOf(filterText) > -1;
    });
  }

  hasPreventsAdServing(warnings: any[]): boolean {
    return !!_.find(warnings || [], (warning) => warning.preventsAdServing);
  }

  onSelect(): void {
    const lineItemId = _.get(this.lineItem, 'id');
    if (!lineItemId) {
      return;
    }
    this.loadingCreatives = true;
    this.creatives = undefined;
    this.Creative.query({lineItem: lineItemId, concise: true, pageSize: 201}, (page: any) => {
      deferMarkForCheck(this.cdr, () => {
        this.creatives = page.results;
        this.loadingCreatives = false;
      });
    });
  }

  copyCreative(creative: any): void {
    creative.nameNeeded = false;
    if (!this.newName) {
      creative.nameNeeded = true;
      return;
    }

    creative.copyDone = false;
    creative.copyError = false;
    creative.thinking = true;

    const copyPayload = _.cloneDeep(creative);
    copyPayload.name = this.newName.replace('{currentName}', creative.name);
    const newId = Uuid.generate();
    const copyRequest = this.Creative.copyCreative(copyPayload, this.destinationLineItem, newId);
    Promise.resolve(copyRequest.$promise || copyRequest).then(() => {
      deferMarkForCheck(this.cdr, () => {
        creative.copyDone = true;
        creative.thinking = false;
      });
    }, () => {
      deferMarkForCheck(this.cdr, () => {
        creative.copyError = true;
        creative.thinking = false;
      });
    });
  }

  dismiss(): void {
    this.bsModalRef.hide();
  }
}
